import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Award, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function RecentSkillBadges() {
  // TODO: Replace with actual skill data
  const recentSkills = [
    { id: 1, name: 'React Hooks', date: '2 days ago', category: 'Technical' },
    { id: 2, name: 'Git Workflows', date: '5 days ago', category: 'Technical' },
    { id: 3, name: 'Problem Solving', date: '1 week ago', category: 'Soft Skill' },
    { id: 4, name: 'Firebase Auth', date: '1 week ago', category: 'Technical' },
    { id: 5, name: 'Code Reviews', date: '2 weeks ago', category: 'Career' },
  ];

  return (
    <Card className="bg-card shadow-md border-border hover:shadow-lg transition-shadow">
      <CardHeader>
        <CardTitle className="text-lg font-bold text-primary flex items-center gap-2">
          <div className="p-1.5 rounded-md bg-accent/10">
            <Award className="h-5 w-5 text-accent" />
          </div>
          Recent Skill Achievements
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
          {recentSkills.map((skill) => (
            <div key={skill.id} className="flex flex-col gap-1.5 p-3 rounded-lg bg-muted/30 hover:bg-muted/50 transition-colors">
              <Badge variant="branch" className="text-xs w-fit">
                {skill.name}
              </Badge>
              <span className="text-xs text-muted-foreground">{skill.date}</span>
              <span className="text-[10px] text-muted-foreground font-medium">{skill.category}</span>
            </div>
          ))}
        </div>
        
        <Button variant="link" className="p-0 text-primary hover:text-primary/80" asChild>
          <Link to="/skill-map">
            View Full Skill Map <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
}
